/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Tab_My_JobsInputs */

const en_jobs_tab_my_jobs = /** @type {(inputs: Jobs_Tab_My_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Jobs`)
};

const de_jobs_tab_my_jobs = /** @type {(inputs: Jobs_Tab_My_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Stellen`)
};

const fr_jobs_tab_my_jobs = /** @type {(inputs: Jobs_Tab_My_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes emplois`)
};

const es_jobs_tab_my_jobs = /** @type {(inputs: Jobs_Tab_My_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis empleos`)
};

const it_jobs_tab_my_jobs = /** @type {(inputs: Jobs_Tab_My_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I miei lavori`)
};

const nl_jobs_tab_my_jobs = /** @type {(inputs: Jobs_Tab_My_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mijn banen`)
};

const pl_jobs_tab_my_jobs = /** @type {(inputs: Jobs_Tab_My_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje oferty`)
};

const fi_jobs_tab_my_jobs = /** @type {(inputs: Jobs_Tab_My_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omat työpaikat`)
};

const da_jobs_tab_my_jobs = /** @type {(inputs: Jobs_Tab_My_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine job`)
};

const sv_jobs_tab_my_jobs = /** @type {(inputs: Jobs_Tab_My_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mina jobb`)
};

/**
* | output |
* | --- |
* | "My Jobs" |
*
* @param {Jobs_Tab_My_JobsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_tab_my_jobs = /** @type {((inputs?: Jobs_Tab_My_JobsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Tab_My_JobsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_tab_my_jobs(inputs)
	if (locale === "fr") return fr_jobs_tab_my_jobs(inputs)
	if (locale === "es") return es_jobs_tab_my_jobs(inputs)
	if (locale === "it") return it_jobs_tab_my_jobs(inputs)
	if (locale === "nl") return nl_jobs_tab_my_jobs(inputs)
	if (locale === "pl") return pl_jobs_tab_my_jobs(inputs)
	if (locale === "fi") return fi_jobs_tab_my_jobs(inputs)
	if (locale === "da") return da_jobs_tab_my_jobs(inputs)
	if (locale === "sv") return sv_jobs_tab_my_jobs(inputs)
	return en_jobs_tab_my_jobs(inputs)
});